"use strict";
var _IrrigationSequentialSchedule_instances, _IrrigationSequentialSchedule_getCyclesRollover, _IrrigationSequentialSchedule_toSortedIndices, _IrrigationSequentialSchedule_randomizeGroups, _IrrigationSequentialSchedule_joinRuns, _IrrigationSequentialSchedule_calculateTimeDifferent;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrrigationSequentialSchedule = void 0;
const tslib_1 = require("tslib");
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const customParseFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/customParseFormat"));
const duration_1 = tslib_1.__importDefault(require("dayjs/plugin/duration"));
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
const typeName = 'IrrigationSequentialSchedule';
const MINUTES_IN_DAY = 24 * 60; //1440
let MVCControlDefaults = {
    valveStartFirst: true,
    valveEndFirst: true,
};
class IrrigationSequentialSchedule extends datamodel_core_1.ModelCommon {
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        super(ob.type || typeName, ob);
        _IrrigationSequentialSchedule_instances.add(this);
        _IrrigationSequentialSchedule_calculateTimeDifferent.set(this, (start, end) => {
            let diff = (0, DefinitionAndHelpers_1.getTimeDifferenceInMinutes)(start, (0, datamodel_core_1.getModifedTime)(end, 0, 'add'));
            return Math.min(MINUTES_IN_DAY, diff);
        });
        this.getHash = () => (0, iotv_v3_types_1.getObjectHash)(this);
        this.name = (_a = ob.name) !== null && _a !== void 0 ? _a : '';
        this.active = (_b = ob.active) !== null && _b !== void 0 ? _b : false;
        this.dayMask = (_c = ob.dayMask) !== null && _c !== void 0 ? _c : [];
        this.cycles = (_d = ob.cycles) !== null && _d !== void 0 ? _d : [(0, DefinitionAndHelpers_1.generateDefaultCycle)(this.dayMask, 0)];
        this.valves = (_e = ob.valves) !== null && _e !== void 0 ? _e : [];
        this.zones = (_f = ob.zones) !== null && _f !== void 0 ? _f : [];
        this.updated_at = ob.updated_at;
        this.application_history = ob.application_history;
        this.mvcControls = (_g = ob.mvcControls) !== null && _g !== void 0 ? _g : MVCControlDefaults;
        this.groupingSize = (_h = ob.groupingSize) !== null && _h !== void 0 ? _h : 1;
    }
    /** Simple getters */
    getCycleSize() {
        return this.cycles.length;
    }
    getZoneSize() {
        return this.zones.length;
    }
    /**
     * Function to get the zone indexs of each cycle, as they can now be moved around
     * @param zoneSupport Provide either the index, or the id of the zone
     */
    getZoneIndex(zoneSupport) {
        let zoneIndex = zoneSupport;
        if (typeof zoneIndex === 'string') {
            zoneIndex = this.zones.findIndex((ids) => ids === zoneSupport);
        }
        if (zoneIndex === -1) {
            return [];
        }
        else {
            return this.cycles.map((val) => (val.zones ? val.zones.findIndex((zoneID) => zoneID === zoneIndex) : zoneIndex));
        }
    }
    /**
     * Get the rollover state of the particular cycle
     * @param cycle index of cycle we care about
     * @returns list of boolean if the current row would be rolling over
     */
    getRollover(cycle) {
        let rolloverSet = Array(this.getZoneSize()).fill(false);
        let relevantCycle = this.cycles[cycle];
        const startTime = relevantCycle.start_time;
        const endTime = relevantCycle.start_time.map((time, i) => (0, DefinitionAndHelpers_1.getEndTime)(time, relevantCycle.duration[i]));
        startTime.forEach((start, i) => {
            const previous = i - 1;
            if (i > 0) {
                if (start === endTime[previous]) {
                    if (rolloverSet[previous] === true || startTime[previous].localeCompare(start) === 1) {
                        rolloverSet[i] = true;
                    }
                }
            }
        });
        return rolloverSet;
    }
    /**
     * Get the duration for the particular zone
     * @param index default index of the zone
     * @returns
     */
    getZoneDuration(index) {
        const indexList = this.getZoneIndex(index);
        return this.cycles
            .map((cycle, i) => {
            var _a;
            const dayMaskCount = ((_a = cycle.dayMask) !== null && _a !== void 0 ? _a : this.dayMask).length;
            const cycleDuration = cycle.duration[indexList[i]];
            return dayMaskCount * cycleDuration;
        })
            .reduce((acc, cur) => {
            acc += cur;
            return acc;
        }, 0);
    }
    /**
     * Get the rollovers of a particualr zone
     * @param index
     * @returns
     */
    getZonesRollover(index) {
        const indexList = this.getZoneIndex(index);
        return this.cycles.map((_, i) => {
            return tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_instances, "m", _IrrigationSequentialSchedule_getCyclesRollover).call(this, i, indexList[index]);
        });
    }
    sortByName(groups) {
        var _a;
        const groupIDByName = (0, datamodel_core_1.sortHumanReadable)(groups, 'name').map((val) => val.id);
        const referenceCycle = this.zones.map((val) => groupIDByName.findIndex((id) => id === val));
        for (let i = 0; i < this.getCycleSize(); i++) {
            const localZone = (_a = this.cycles[i].zones) !== null && _a !== void 0 ? _a : (0, DefinitionAndHelpers_1.IncreasingArrayGenerator)(this.zones.length);
            const updatedDuration = localZone.map((local) => {
                const localIndex = referenceCycle.findIndex((val) => val === local);
                return this.cycles[i].duration[localIndex];
            });
            this.cycles[i].duration = updatedDuration;
            this.cycles[i].zones = referenceCycle;
        }
    }
    sortByTime() {
        for (let i = 0; i < this.getCycleSize(); i++) {
            this.sortByCycle(i);
        }
    }
    sortByCycle(cycle) {
        let localCycle = this.cycles[cycle];
        const indicies = tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_instances, "m", _IrrigationSequentialSchedule_toSortedIndices).call(this, localCycle.start_time);
        const updatedDuration = indicies.map((i) => localCycle.duration[i]);
        const updatedStartTime = indicies.map((i) => localCycle.start_time[i]);
        const updatedZones = indicies.map((i) => { var _a, _b; return (_b = (_a = localCycle === null || localCycle === void 0 ? void 0 : localCycle.zones) === null || _a === void 0 ? void 0 : _a[i]) !== null && _b !== void 0 ? _b : i; });
        this.cycles[cycle].duration = updatedDuration;
        this.cycles[cycle].start_time = updatedStartTime;
        this.cycles[cycle].zones = updatedZones;
    }
    randomizeAll(groupSizing, linkStartTime, linkAcrossCycle) {
        for (let i = 0; i < this.cycles.length; i++) {
            tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_instances, "m", _IrrigationSequentialSchedule_randomizeGroups).call(this, groupSizing, i, linkStartTime, linkAcrossCycle);
        }
    }
    moveZone(cycle, row, groupSizing, direction) {
        var _a, _b, _c;
        let localZones = (_a = this.cycles[cycle].zones) !== null && _a !== void 0 ? _a : Array.from({ length: this.zones.length }, (_, index) => index);
        let localDuration = (_b = this.cycles[cycle].duration) !== null && _b !== void 0 ? _b : Array.from({ length: this.zones.length }, (_, index) => 1);
        let holdZone = localZones[row];
        let holdDuration = (_c = this.cycles[cycle].duration[row]) !== null && _c !== void 0 ? _c : 1;
        let pos = row;
        switch (direction) {
            case 'UP':
                pos = row - 1;
                break;
            case 'DOWN':
                pos = row + 1;
                break;
        }
        localZones[row] = localZones[pos];
        localZones[pos] = holdZone;
        localDuration[row] = localDuration[pos];
        localDuration[pos] = holdDuration;
        this.cycles[cycle].zones = localZones;
        this.cycles[cycle].duration = localDuration;
        this.flowTime(cycle, Math.min(pos, row), false, groupSizing);
    }
    /**Simple Setters */
    setName(newName) {
        this.name = newName;
    }
    setCycleCount(newCount) {
        if (this.getCycleSize() < newCount) {
            // add new
            // const newCycle = generateDefaultCycle(this.dayMask, this.zones.length)
            let updatedCycle = [...this.cycles];
            while (updatedCycle.length < newCount) {
                updatedCycle.push((0, DefinitionAndHelpers_1.generateDefaultCycle)(this.dayMask, this.zones.length));
            }
            this.cycles = updatedCycle;
        }
        else {
            // trim cycle count
            this.cycles = this.cycles.slice(0, newCount);
        }
    }
    // remove zones, as well as cycle count from the list
    setZones(groupIDS) {
        this.zones = groupIDS;
        const groupsLength = groupIDS.length;
        let updatedCycles = this.cycles.map((cycle) => {
            var _a;
            let updatedDuration = cycle.duration.slice(0, groupsLength);
            let updatedStartTime = cycle.start_time.slice(0, groupsLength);
            while (updatedDuration.length < this.zones.length) {
                updatedStartTime.push((0, DefinitionAndHelpers_1.getEndTime)(updatedStartTime.at(-1), (_a = updatedDuration.at(-1)) !== null && _a !== void 0 ? _a : 0));
                updatedDuration.push(1);
            }
            let filteredZones = cycle.zones ? cycle.zones.filter((val) => val < groupsLength) : undefined;
            if (filteredZones) {
                while (filteredZones.length < groupsLength) {
                    filteredZones.push(filteredZones.length);
                }
            }
            return {
                dayMask: cycle.dayMask,
                duration: updatedDuration,
                start_time: updatedStartTime,
                zones: filteredZones,
            };
        });
        this.cycles = updatedCycles;
    }
    setMVCShift(direction, valveFirst) {
        if (!this.mvcControls) {
            this.mvcControls = MVCControlDefaults;
        }
        this.mvcControls[direction === 'START' ? 'valveStartFirst' : 'valveEndFirst'] = valveFirst;
    }
    setDayMask(dayMask, specific) {
        if (specific === undefined) {
            this.dayMask = dayMask;
            let copyMask = [...this.cycles];
            copyMask = copyMask.map((specific) => {
                return { ...specific, dayMask };
            });
            this.cycles = copyMask;
        }
        else {
            let copyMask = [...this.cycles];
            copyMask[specific].dayMask = dayMask;
            this.cycles = copyMask;
        }
    }
    setMasterValve(valveIDS) {
        this.valves = valveIDS;
    }
    /**
     * The logic to calculate the distributed time can be matched to resistors in a parellel circuit
     * 1. Calculate the effective resistance (1/R of rate)
     * 2. Calculate the overall voltage (application)
     * 3. Calculate the current for each resistance (time)
     *
     * @returns the effective application
     */
    setDesiredCyclePeriod(cycle, sameDuration, period, applicationRate, durationLimit, linkStart, linkAcrossCycle) {
        var _a, _b;
        // convert all as a ratio of the first
        if (applicationRate.length === 0)
            return;
        const inverseSumOfRate = applicationRate.reduce((acc, cur) => {
            acc += 1 / cur;
            return acc;
        }, 0);
        const effectiveRate = 1 / inverseSumOfRate;
        const totalApplication = effectiveRate * period; // (Effective Voltage)
        const durationList = applicationRate.map((application, i) => Math.min(durationLimit[i], Math.max(1, Math.floor(totalApplication / application))));
        if (sameDuration) {
            const referenceCycle = (_a = this.cycles[cycle].zones) !== null && _a !== void 0 ? _a : (0, DefinitionAndHelpers_1.IncreasingArrayGenerator)(this.zones.length);
            for (let i = cycle; i < this.cycles.length; i++) {
                // get local zone
                const localZone = (_b = this.cycles[i].zones) !== null && _b !== void 0 ? _b : (0, DefinitionAndHelpers_1.IncreasingArrayGenerator)(this.zones.length);
                const localDurationList = localZone.map((index, i) => {
                    let mappedIndex = referenceCycle.findIndex((val) => index === val);
                    return durationList[mappedIndex];
                });
                // get mapping according to the know cycle
                this.cycles[i].duration = localDurationList;
            }
        }
        else {
            this.cycles[cycle].duration = durationList;
        }
        linkStart && this.flowTime(sameDuration ? 0 : cycle, 0, !linkAcrossCycle, 1); //groupSizing
        const appInMin = totalApplication / 60;
        if (appInMin < 1) {
            return (0, datamodel_core_1.roundDecimals)(appInMin, 1);
        }
        return Math.round(appInMin);
    }
    /**
     *
     * @returns the cycle duration
     */
    setDesiredApplication(cycle, sameDuration, desiredRate, applicationRate, durationLimit, linkStart, linkAcrossCycle, groupSizing) {
        var _a, _b;
        // need to change for each cycle
        const durationList = applicationRate.map((rate, i) => Math.min(durationLimit[i], Math.max(1, Math.floor((desiredRate / rate) * 60))));
        if (sameDuration) {
            const referenceCycle = (_a = this.cycles[cycle].zones) !== null && _a !== void 0 ? _a : (0, DefinitionAndHelpers_1.IncreasingArrayGenerator)(this.zones.length);
            // need to calculate durationList for each cycle order
            for (let i = cycle; i < this.getCycleSize(); i++) {
                // get local zone
                const localZone = (_b = this.cycles[i].zones) !== null && _b !== void 0 ? _b : (0, DefinitionAndHelpers_1.IncreasingArrayGenerator)(this.zones.length);
                const localDurationList = localZone.map((index, i) => {
                    let mappedIndex = referenceCycle.findIndex((val) => index === val);
                    return durationList[mappedIndex];
                });
                // get mapping according to the know cycle
                this.cycles[i].duration = localDurationList;
            }
        }
        else {
            this.cycles[cycle].duration = durationList;
        }
        linkStart && this.flowTime(sameDuration ? 0 : cycle, 0, !linkAcrossCycle, groupSizing);
        // get all start times
        let numArray = Array(groupSizing).fill(0);
        durationList.forEach((dur, i) => {
            numArray[i % groupSizing] += dur;
        });
        const summedAmount = Math.max(...numArray);
        // const summedAmount = durationList.reduce((acc, cur) => {
        //   acc += cur
        //   return acc
        // }, 0)
        return summedAmount;
    }
    updateGroupingSize(newGroupSize, linkAcrossCycle) {
        this.flowTime(0, 0, false, newGroupSize, linkAcrossCycle);
        this.groupingSize = newGroupSize;
    }
    /** Returns total duration for this cycle */
    setUpdateTime(cycle, index, ifSameDur, ifTimeFlow, ifAcrossCycle, groupSizing, durationLimit, duration, startTime) {
        if (duration) {
            const durationFromZero = Math.min(Math.max(0, duration), DefinitionAndHelpers_1.MVC_DURATION_LIMIT);
            if (ifSameDur) {
                const grouplength = this.cycles[cycle].start_time.length;
                const durationResult = Array(grouplength)
                    .fill(durationFromZero)
                    .map((val, i) => {
                    return Math.min(val, durationLimit[i]);
                });
                this.cycles[cycle].duration = durationResult;
            }
            else {
                this.cycles[cycle].duration[index] = Math.min(durationFromZero, durationLimit[index]);
            }
        }
        else if (startTime) {
            this.cycles[cycle].start_time[index] = startTime;
        }
        if (ifTimeFlow) {
            this.flowTime(cycle, ifSameDur ? 0 : index, !ifAcrossCycle, groupSizing);
            // this.flowTime(cycle, index, !ifAcrossCycle, startTime ? 1 : groupSizing) //groupSizing
        }
        const durationSum = this.cycles[cycle].duration.reduce((acc, cur) => {
            acc += cur;
            return acc;
        }, 0);
        return durationSum;
    }
    /**
     * Sets the start time of the group to begin after another finishes.
     * @param cycle The start point of the flow
     * @param index The starting order of the flow
     */
    flowTime(cycle, index, onlyThisCycle, groupSizing, matchStartAcrossCycle = true) {
        const zoneSize = this.getZoneSize();
        // let last = this.cycles[cycle].start_time[index]
        // let lastDuration = this.cycles[cycle].duration[index]
        const cycleSize = onlyThisCycle ? cycle + 1 : this.getCycleSize();
        // iterate through all cycles from the cycle number i
        for (let i = cycle; i < cycleSize; i++) {
            // go through each order in the cycle
            for (let zoneIndex = 0; zoneIndex < zoneSize; zoneIndex++) {
                // if the cycle we are looking at is greater than the one we started at, or if the current order is greater than the one we started
                if (i > cycle || zoneIndex > index) {
                    // get the end time of group size
                    let lastStart;
                    // if is the start of the index
                    if (zoneIndex < groupSizing) {
                        if (!matchStartAcrossCycle || i === 0) {
                            // use existing start time; ignore change
                            lastStart = this.cycles[i].start_time[0];
                        }
                        else {
                            let lastCycleStart = this.cycles[i - 1].start_time[zoneSize - 1];
                            const lastCycleDuration = this.cycles[i - 1].duration[zoneSize - 1];
                            lastStart = (0, DefinitionAndHelpers_1.getEndTime)(lastCycleStart, lastCycleDuration);
                            // get end time of the last cycle
                        }
                    }
                    else {
                        const indexRelated = Math.max(0, zoneIndex - groupSizing); //
                        lastStart = (0, DefinitionAndHelpers_1.getEndTime)(this.cycles[i].start_time[indexRelated], this.cycles[i].duration[indexRelated]);
                    }
                    this.cycles[i].start_time[zoneIndex] = lastStart;
                }
            }
        }
        // let last = this.cycles[cycle].start_time[index]
        // let lastDuration = this.cycles[cycle].duration[index]
        // const cycleSize = onlyThisCycle ? cycle + 1 : this.getCycleSize()
        // for (let i = cycle; i < cycleSize; i++) {
        //   for (let zoneIndex = 0; zoneIndex < zoneSize; zoneIndex++) {
        //     if (i > cycle || zoneIndex > index) {
        //       last = getEndTime(last, lastDuration)
        //       if (!matchStartAcrossCycle && zoneIndex === 0) {
        //         last = this.cycles[i].start_time[zoneIndex]
        //       }
        //       this.cycles[i].start_time[zoneIndex] = last
        //       lastDuration = this.cycles[i].duration[zoneIndex]
        //     }
        //   }
        // }
    }
    getMVCCycleProgramme(startPaddingSec, endPaddingSec, showAP = true) {
        var _a;
        let cycles = [];
        let zonesUsed = ((_a = this.zones) !== null && _a !== void 0 ? _a : []).length;
        // let delay = this.mvcDelay ?? 0
        try {
            if (this.cycles && zonesUsed !== 0) {
                cycles = this.cycles.map((val) => {
                    // set start durations
                    var _a;
                    const last = val.start_time.length - 1;
                    let bufferChange = 0;
                    let startAction = 'add';
                    if (this.mvcControls) {
                        if (this.mvcControls.valveStartFirst) {
                            startAction = 'subtract';
                            bufferChange += startPaddingSec;
                        }
                        else {
                            bufferChange -= startPaddingSec;
                        }
                        // if (this.mvcControls.valveEndFirst) {
                        //   bufferChange -= endPaddingSec
                        // } else {
                        //   bufferChange += endPaddingSec
                        // }
                    }
                    else {
                        // using old format
                        bufferChange = startPaddingSec + endPaddingSec;
                    }
                    const startAsMin = Math.round(startPaddingSec / 60);
                    const bufferAsMin = Math.round(bufferChange / 60);
                    let mvcStartTime = (0, datamodel_core_1.getModifedTime)(val.start_time[0], startAsMin, startAction);
                    let duration = 0;
                    if (zonesUsed === 1) {
                        duration = val.duration[0]; // - delay
                    }
                    else {
                        let indexTwo = Math.max(last - 1, 0);
                        let indexThree = Math.max(indexTwo - 1, 0);
                        const finalPeriodOne = val.duration[last] + (startAction === 'add' ? bufferAsMin : -bufferAsMin);
                        const finalPeriodTwo = val.duration[indexTwo] + (startAction === 'add' ? bufferAsMin : -bufferAsMin);
                        const finalPeriodThree = val.duration[indexThree] + (startAction === 'add' ? bufferAsMin : -bufferAsMin);
                        let programmeFinishTimeOne = (0, datamodel_core_1.getModifedTime)(val.start_time[last], finalPeriodOne, 'add');
                        let programmeFinishTimeTwo = (0, datamodel_core_1.getModifedTime)(val.start_time[indexTwo], finalPeriodTwo, 'add');
                        let programmeFinishTimeThree = (0, datamodel_core_1.getModifedTime)(val.start_time[indexThree], finalPeriodThree, 'add');
                        // let diff = getTimeDifferenceInMinutes(mvcStartTime, programmeFinishTimeOne)
                        let diffOne = (0, DefinitionAndHelpers_1.getTimeDifferenceInMinutes)(mvcStartTime, programmeFinishTimeOne);
                        let diffTwo = (0, DefinitionAndHelpers_1.getTimeDifferenceInMinutes)(mvcStartTime, programmeFinishTimeTwo);
                        let diffThree = (0, DefinitionAndHelpers_1.getTimeDifferenceInMinutes)(mvcStartTime, programmeFinishTimeThree);
                        duration = Math.max(diffOne, diffTwo, diffThree);
                    }
                    // duration -= delay // not x2 as the `firstTime` has already been shifted
                    duration = Math.min(MINUTES_IN_DAY, duration); // in case the duration is for the entire day
                    return {
                        start_time: [(0, datamodel_core_1.formatDayJS)(mvcStartTime, showAP)],
                        duration: [duration],
                        dayMask: (_a = val.dayMask) !== null && _a !== void 0 ? _a : this.dayMask,
                    };
                });
            }
            // const dayMaskMapper = this.cycles.map((val) => val.dayMask ?? this.dayMask)
            let res = tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_instances, "m", _IrrigationSequentialSchedule_joinRuns).call(this, cycles);
            return res;
        }
        catch (e) {
            console.log('Missing data in MVCCycle');
            return null;
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            Name: {
                type: 'RelatedType',
                editable: false,
                label: 'Name',
                name: 'Name',
                description: 'Name of schedule eg Westerly',
                objectTypeId: 'User',
                direction: iotv_v3_types_1.PathDirection.child,
                edgeTypeId: 'Irrigation_Sequential_Programme_has_Name_User',
            },
            timeCreated: {
                type: 'Number',
                editable: true,
                label: 'Time Created',
                name: 'timeCreated',
                description: 'Date and time schedule was created',
            },
            startTime: {
                type: 'String',
                editable: true,
                label: 'Start Time',
                name: 'startTime',
                description: 'When the first programme starts',
            },
            userCreated: {
                type: 'String',
                editable: true,
                label: 'User Created ',
                name: 'userCreated',
                description: 'User that created schedule',
            },
            areaCovered: {
                type: 'Number',
                editable: true,
                label: 'Area covered',
                name: 'areaCovered',
                description: 'Aggregate of area covered by irrigation ',
            },
            waterApplied: {
                type: 'Number',
                editable: true,
                label: 'Water applied',
                name: 'waterApplied',
                description: 'Calculated amount of water to be applied at x pressure for y duration',
            },
            irrigationCycle: {
                type: 'Number',
                editable: true,
                label: 'Irrigation Cycle Amount',
                name: 'irrigationCycle',
                description: 'The number of programme cycles',
            },
            dayMask: {
                type: 'Enum',
                editable: true,
                label: 'Day Mask Selection',
                name: 'dayMask',
                description: 'When the programme should run (local)',
            },
        };
    }
}
exports.IrrigationSequentialSchedule = IrrigationSequentialSchedule;
_IrrigationSequentialSchedule_calculateTimeDifferent = new WeakMap(), _IrrigationSequentialSchedule_instances = new WeakSet(), _IrrigationSequentialSchedule_getCyclesRollover = function _IrrigationSequentialSchedule_getCyclesRollover(cycle, index) {
    const all = this.getRollover(cycle);
    return all[index];
}, _IrrigationSequentialSchedule_toSortedIndices = function _IrrigationSequentialSchedule_toSortedIndices(arr) {
    const sorted = [...arr].sort((a, b) => a.localeCompare(b));
    let indexMap = arr.map((value, index) => [value, index]);
    let res = [];
    sorted.forEach((specific) => {
        let pairFound = indexMap.find((val) => val[0] === specific && ~res.includes(val[1]));
        if (pairFound) {
            res.push(pairFound[1]);
        }
    });
    return res;
}, _IrrigationSequentialSchedule_randomizeGroups = function _IrrigationSequentialSchedule_randomizeGroups(groupSizing, cycle, linkStartTime, changingAll = false) {
    const numbers = Array.from({ length: this.zones.length }, (_, index) => index);
    const shuffledZones = (0, DefinitionAndHelpers_1.shuffle)(numbers);
    this.cycles[cycle].duration = shuffledZones.map((order) => {
        var _a;
        let relativeIndex = ((_a = this.cycles[cycle].zones) !== null && _a !== void 0 ? _a : numbers).findIndex((val) => val === order);
        return this.cycles[cycle].duration[relativeIndex !== null && relativeIndex !== void 0 ? relativeIndex : order];
    });
    this.cycles[cycle].zones = shuffledZones;
    linkStartTime && this.flowTime(cycle, 0, !changingAll, groupSizing);
}, _IrrigationSequentialSchedule_joinRuns = function _IrrigationSequentialSchedule_joinRuns(programme) {
    const mergedCycles = programme;
    const startEndArray = mergedCycles
        .map((val) => {
        var _a;
        if (val.start_time.at(-1) && val.duration.at(-1)) {
            return {
                start: val.start_time[0],
                end: (0, datamodel_core_1.formatDayJS)((0, datamodel_core_1.getModifedTime)(val.start_time.at(-1), val.duration.at(-1), 'add')),
                dayMask: (_a = val.dayMask) !== null && _a !== void 0 ? _a : this.dayMask,
            };
        }
    })
        .filter((val) => val !== undefined);
    const linkChecker = startEndArray.map((val, i) => {
        if (i === 0) {
            return false;
        }
        // if start is the same as the last end
        const sameStartEnd = val.start == startEndArray[i - 1].end;
        // if on the same 24hours, same day mask pattern, or if next 24 hour day, day mask shift of one
        // last start time is earlier than this start time  && day mask is the same
        const sameDaySameDaymask = JSON.stringify(startEndArray[i - 1].dayMask) === JSON.stringify(val.dayMask) && startEndArray[i - 1].start.localeCompare(val.start) === -1;
        const differentDayShiftedMask = JSON.stringify(startEndArray[i - 1].dayMask) === JSON.stringify((0, DefinitionAndHelpers_1.dayShift)(val.dayMask, 'UP')) &&
            startEndArray[i - 1].start.localeCompare(val.start) !== -1;
        return sameStartEnd && (sameDaySameDaymask || differentDayShiftedMask);
    });
    const linkRes = [];
    let cachedStart;
    let cachedEnd;
    let cachedDaymask;
    for (let i = 0; i < linkChecker.length; i++) {
        let specific = startEndArray[i];
        if (linkChecker[i] === false || cachedStart === undefined) {
            cachedStart = (0, datamodel_core_1.getModifedTime)(specific.start, 0, 'add');
            cachedEnd = specific.end;
            cachedDaymask = specific.dayMask;
        }
        else {
            cachedEnd = specific.end;
        }
        if (cachedDaymask && (i === linkChecker.length - 1 || linkChecker[i + 1] === false)) {
            // the end, generate the duration
            linkRes.push({ start_time: [(0, datamodel_core_1.formatDayJS)(cachedStart)], duration: [tslib_1.__classPrivateFieldGet(this, _IrrigationSequentialSchedule_calculateTimeDifferent, "f").call(this, cachedStart, cachedEnd)], dayMask: cachedDaymask });
        }
    }
    return linkRes;
};
tslib_1.__decorate([
    (0, datamodel_core_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], IrrigationSequentialSchedule.prototype, "getHash", void 0);
